import * as React from 'react';
import { getConfig } from '../config';
import { useShowTag } from '../hooks/ad';
import { getBannerProximityByPlacementId } from '../utils/banner-proximity';
import { PlacementId } from '../../shared/types/ast';
import { useMemo } from 'react';

export type Props = {
    id: string;
    targetId: string;
    pageType?: string;
    className?: string;
    deviceType?: string;
    vertical?: string;
    grid?: boolean;
    adSize?: {
        width: number;
        height: number;
    };
};

export function Banner(props: Props) {
    const {
        id,
        targetId,
        pageType,
        className = 'grid overflow-hidden relative transition-all outline-none col-span-full',
        adSize,
    } = props;

    const { subvertical } = getConfig();
    const noFabricOnPage = subvertical === 'prepackage';

    const { proximity = 0, threshold = 0.0 } = useMemo(() => {
        return getBannerProximityByPlacementId(id as PlacementId, adSize);
    }, [id, adSize]);

    useShowTag(targetId, proximity, threshold);

    if (pageType && pageType === 'object') {
        // Rendered from objectpages-podium already
        return null;
    }
    let containerClassName = className;
    let boardClassName = 'inline mx-auto';

    if (noFabricOnPage) {
        containerClassName = 'ads__unit ads__unit--banner ads__unit--fullwidth';
        boardClassName = `inline-container ${id}-inline-container`;
    }

    return (
        <div id={`${targetId}-container`} className={containerClassName}>
            <div id={targetId} className={boardClassName}>
                <span className="ad-info-wrap">
                    <div
                        id={`${targetId}-button`}
                        className="ad-info"
                        style={{ maxWidth: 26, maxHeight: 26 }}
                    />
                </span>
            </div>
        </div>
    );
}
